<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择司机"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :fnRadioDisabled="fnRadioDisabled"
      :querySearchAsync="querySearchAsync"
      :isInput="isInput"
      :placeholder="placeholder"
      :onSelect="onSelect"
      valueKey="linkmanAndMobilePhone"
      :disabled="disabled"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{ scope.row[scope.column.property] }}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  driverArchivesList,
} from 'api/archives';
import {
  doQueryCarDriver,
} from 'api/car';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    fnRadioDisabled: {
      type: Function,
    },
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    showName: { // 选中值展示字段
      type: String,
      default: 'linkman',
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInput: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    queryFunction: {
      type: Function,
    },
  },
  data () {
    return {
      defaultSearchData: {},
      tableSelectTar: 'loginAcct',
      searchBoxDataTmpl: {
        form: [
          { // 司机姓名
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 司机手机
            label: '司机手机',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入司机手机',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'linkman',
          label: '司机姓名',
        },
        {
          prop: 'loginAcct',
          label: '司机手机',
        },
        {
          prop: 'carUserTypeName',
          label: '司机类型',
        },
        {
          prop: 'stateName',
          label: '状态',
        },
        {
          prop: 'entryStateName',
          label: '在职状态',
        },
      ],
    };
  },
  methods: {
    getListApi: driverArchivesList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    querySearchAsync (queryString, cb) {
      let resInfo = [];
      if (queryString && queryString.length) {
        doQueryCarDriver({
          rows: 1000,
          mobilePhone: queryString,
          random: Math.random(),
        }).then((res) => {
          if (res && res.items) {
            res.items.forEach((item) => {
              item.loginAcct = `${item.mobilePhone}`;
              item.linkmanAndMobilePhone = `${item.linkman}（${item.mobilePhone}）`;
            });
            const filterData = res.items.filter((item) => item.mobilePhone.includes(queryString));
            resInfo = filterData;
          }
          cb(resInfo);
        });
      } else {
        // 当没有输入的时候
        resInfo = this.defaultSearchData.items;
        cb(resInfo);
      }
    },
    onSelect (item) {
      if (item) {
        this.$refs.chooseTmpl.chooseSelectItem(item);
      }
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>
</style>
